import { FC } from "react";
import { pluralizeWithCount } from "@common/helpers/string";
import { CommandsListProps } from "./lib";
import { TaskBulkOptionsCommandsList } from "./TaskBulkOptionsCommandsList";

export const InvoiceBulkCounterpartyCommandsList: FC<CommandsListProps> = ({
    options = {},
}) => {
    const { selectedInvoiceCount = 0, invoiceBulkCounterpartyOptions = [] } =
        options;

    return (
        <TaskBulkOptionsCommandsList
            heading={`Set counterparty for ${pluralizeWithCount("invoice", selectedInvoiceCount)}`}
            options={invoiceBulkCounterpartyOptions}
        />
    );
};
